import { Link } from 'react-router-dom';

const FailureTwo = () => {


    return (
        <>
        <div className="knowledgetitle">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-lg-6">
                            <div className="page-tit">
                                <h1>knowledge Base</h1>
                            </div>
                        </div>

                        <div className="col-md-12 col-lg-6">
                            <div className="breadcrumb-page">
                                <ul>
                                    <li><Link to="/">Home</Link></li>
                                    <li>Pump Failure Modes - Cavitation</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pdf-sec mt-5 mb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="text-center mb-3">Pump Failure Modes - Cavitation</h4>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="pdf-knowledge">
                            <img src='images/knowledge/pump-failure-modes-cavitation.webp' />
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </>
    )
}

export default FailureTwo;